import { Capacitor } from '@capacitor/core'

const oAuthConfig = {
  host: 'https://api.fich.app',
  redirectTarget: 'http://127.0.0.1:4120/login_redirect/',
  clientId: 'PKFecRPAiG2BPTYGtB7rJAQVfyCxCKuhn72gmQ1E',
}

if (Capacitor.isNativePlatform()) {
  oAuthConfig.redirectTarget = 'app.fich.svelte://login_redirect/'
} else if (document && document.location) {
  oAuthConfig.redirectTarget =
    document.location.protocol +
    '//' +
    document.location.host +
    '/login_redirect/'
}

oAuthConfig.loginUrl =
  oAuthConfig.host +
  '/o/authorize/?response_type=code&client_id=' +
  oAuthConfig.clientId +
  '&redirect_uri=' +
  encodeURIComponent(oAuthConfig.redirectTarget)

export default oAuthConfig
